module.exports = __webpack_public_path__ + "img/paypal.20b27c49.png";